/**
 * Technische Anlagen / Energieausweis — section chrome: injected styles, the shared table
 * shell and the Impower-style `.sub-section` builder used by `technicalAssetsSection.js`.
 * Row cells live in `technicalAssetsSection.render.js` and
 * `technicalAssetsSection.energyCertificates.js`. All cross-file references are inside
 * function bodies, so gulp concat order between these files does not matter.
 */
function ensureTechnicalAssetsTableStyles() {
  if (document.getElementById('impowerx-technical-assets-table-styles')) return
  const style = document.createElement('style')
  style.id = 'impowerx-technical-assets-table-styles'
  style.textContent = `
    .impowerx-technical-assets-lux-root .sub-section-header { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
    .impowerx-ta-title-count { margin-left: 8px; font-weight: 400; font-size: 12px; color: rgba(0,0,0,.45); }
    .impowerx-ta-create.ant-btn { display: inline-flex; align-items: center; gap: 6px; }
    .impowerx-ta-create.ant-btn .anticon { display: inline-flex; line-height: 0; }
    .impowerx-technical-assets-lux-wrap { margin: 8px 0 4px; }
    .impowerx-technical-assets-lux-wrap * { box-sizing: border-box; }
    /* Controls row, table card and footer match the Versicherungen table (insurancePropertyTableStyles.js). */
    .impowerx-ta-controls { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; padding: 8px; margin-bottom: 16px; border: 1px solid #e5e5e5; border-radius: 8px; background: #fff; }
    .impowerx-ta-filters { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; }
    .impowerx-ta-filters-label { padding: 0 8px; color: #a3a3a3; font-size: 12px; font-weight: 500; }
    .impowerx-ta-search { position: relative; margin-left: auto; }
    .impowerx-ta-search svg { position: absolute; top: 9px; left: 10px; z-index: 1; pointer-events: none; color: #a3a3a3; width: 14px; height: 14px; }
    .impowerx-ta-controls input, .impowerx-ta-controls select { height: 32px; border: 1px solid #d9d9d9; border-radius: 6px; background: #fff; padding: 0 8px; min-width: 0; color: #171717; font: inherit; font-size: 13px; line-height: normal; }
    .impowerx-ta-controls input { width: 260px; padding: 0 12px 0 32px; }
    .impowerx-ta-controls input::placeholder { color: #a3a3a3; }
    .impowerx-ta-filters select { max-width: 220px; }
    /* A little wider than Impower's content column (its wrapper keeps 2.4rem padding; we use 1.6rem of it). Same on the Versicherungen table. */
    .impowerx-technical-assets-lux-root > .sub-section-content { margin-right: -16px; }
    .impowerx-ta-table-wrap { border: 1px solid #e5e5e5; border-radius: 8px; background: #fff; overflow: hidden; }
    .impowerx-ta-table-scroll { overflow-x: auto; }
    .impowerx-ta-table { width: 100%; min-width: 900px; border-collapse: collapse; font-size: 13px; color: rgba(0,0,0,.88); table-layout: fixed; }
    .impowerx-ta-table th { padding: 8px 16px; background: #fafafa; border-bottom: 1px solid #f0f0f0; color: rgba(0,0,0,.45); font-size: 12px; font-weight: 600;
      letter-spacing: .04em; text-transform: uppercase; text-align: left; white-space: normal; line-height: 1.3; }
    .impowerx-ta-table th.impowerx-ta-col-actions { text-align: right; padding-left: 8px; padding-right: 12px; white-space: nowrap; }
    .impowerx-ta-table th[data-sort-key] { cursor: pointer; user-select: none; }
    .impowerx-ta-table th[data-sort-key]:hover { color: rgba(0,0,0,.75); }
    .impowerx-ta-sort { display: inline-flex; align-items: center; gap: 4px; }
    .impowerx-ta-sort svg { flex: 0 0 auto; width: 12px; height: 12px; opacity: .35; }
    .impowerx-ta-table th[aria-sort="ascending"] .impowerx-ta-sort svg, .impowerx-ta-table th[aria-sort="descending"] .impowerx-ta-sort svg { opacity: 1; color: #171717; }
    .impowerx-ta-table th[aria-sort="ascending"], .impowerx-ta-table th[aria-sort="descending"] { color: rgba(0,0,0,.88); }
    .impowerx-ta-table td { padding: 12px 16px; border-bottom: 1px solid #f0f0f0; vertical-align: top; line-height: 1.45; overflow-wrap: anywhere; }
    .impowerx-ta-table tr:last-child td { border-bottom: 0; }
    .impowerx-ta-row:hover td { background: #fafafa; }
    .impowerx-ta-empty td { color: rgba(0,0,0,.45); text-align: center; padding: 22px 16px; }
    .impowerx-ta-loading td { height: 72px; text-align: center; vertical-align: middle; color: #737373; }
    .impowerx-ta-loading .impowerx-ta-spinner { width: 16px; height: 16px; margin-right: 8px; border-color: #d9d9d9; border-top-color: #525252; vertical-align: middle; }
    .impowerx-ta-error td { color: #cf1322; text-align: center; padding: 22px 16px; }
    .impowerx-ta-primary { font-weight: 500; font-size: 14px; line-height: 20px; color: rgba(0,0,0,.88); }
    .impowerx-ta-primary a { color: inherit; text-decoration: none; }
    .impowerx-ta-primary a:hover { color: #1677ff; }
    .impowerx-ta-secondary { color: rgba(0,0,0,.45); font-size: 13px; margin-top: 2px; }
    .impowerx-ta-strong { font-weight: 500; font-size: 13px; }
    .impowerx-ta-line { display: flex; align-items: flex-start; gap: 6px; margin-top: 3px; }
    .impowerx-ta-line svg { flex: 0 0 auto; margin-top: 3px; color: #737373; }
    .impowerx-ta-titleline { display: flex; align-items: center; flex-wrap: wrap; gap: 6px; }
    .impowerx-ta-tag { display: inline-block; padding: 1px 6px; border: 1px solid #e5e5e5; border-radius: 4px; background: #fafafa; color: #404040; font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 11px; white-space: nowrap; }
    .impowerx-ta-tags { display: flex; flex-wrap: wrap; gap: 4px; margin-top: 6px; }
    .impowerx-ta-pill { display: inline-flex; align-items: center; gap: 4px; height: 20px; padding: 0 7px; border: 1px solid transparent; border-radius: 4px; font-size: 11px; font-weight: 600; line-height: 18px; white-space: nowrap; }
    .impowerx-ta-pill::before { content: ''; width: 6px; height: 6px; border-radius: 50%; background: currentColor; }
    .impowerx-ta-pill--ok { background: #ecfdf3; border-color: #abefc6; color: #067647; }
    .impowerx-ta-pill--warn { background: #fffaeb; border-color: #fedf89; color: #b54708; }
    .impowerx-ta-pill--danger { background: #fef3f2; border-color: #fecdca; color: #b42318; }
    .impowerx-ta-pill--muted { background: #f5f5f5; border-color: #e5e5e5; color: #737373; }
    .impowerx-ta-pill--dark { background: #111827; color: #fff; }
    .impowerx-ta-pill--dark::before, .impowerx-ta-pill--light::before { display: none; }
    .impowerx-ta-pill--light { background: #f4f3ff; border-color: #d9d6fe; color: #5925dc; }
    .impowerx-ta-dots { display: flex; flex-wrap: wrap; gap: 2px 10px; margin-top: 6px; color: #525252; font-size: 12px; }
    .impowerx-ta-dots span::before { content: '•'; margin-right: 5px; color: #a3a3a3; }
    .impowerx-ta-doc-pill { display: inline-flex; align-items: center; gap: 6px; height: 26px; padding: 0 9px; border: 1px solid #e5e5e5; border-radius: 4px; background: #fafafa;
      color: #404040; font-size: 12px; font-weight: 500; text-decoration: none; white-space: nowrap; }
    .impowerx-ta-doc-pill:hover { border-color: #a3a3a3; color: #171717; }
    .impowerx-ta-doc-pill svg { color: #737373; }
    .impowerx-ta-company { display: flex; align-items: center; gap: 6px; min-width: 0; }
    .impowerx-ta-company svg { flex: 0 0 auto; color: #737373; }
    .impowerx-ta-company-name { min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
    .impowerx-ta-partners { flex: 0 0 auto; padding: 0 5px; border: 1px solid #e5e5e5; border-radius: 3px; background: #fafafa; color: #737373; font-size: 10px; line-height: 16px; font-weight: 500; white-space: nowrap; cursor: help; }
    .impowerx-ta-partners:hover { background: #e5e7eb; color: rgba(0,0,0,.88); }
    .impowerx-ta-avatar-stack { display: flex; align-items: center; margin-top: 6px; }
    .impowerx-ta-avatar { width: 28px; height: 28px; margin-left: -8px; border: 2px solid #fff; border-radius: 999px; background: #f0f0f0; color: rgba(0,0,0,.75);
      display: inline-flex; align-items: center; justify-content: center; font-size: 10px; font-weight: 600; cursor: default; }
    .impowerx-ta-avatar:first-child { margin-left: 0; }
    .impowerx-ta-avatar--extra { display: none; }
    .impowerx-ta-avatar-stack.is-expanded .impowerx-ta-avatar--extra { display: inline-flex; }
    .impowerx-ta-avatar-more { background: #e6f4ff; color: #1677ff; cursor: pointer; padding: 0; }
    .impowerx-ta-table .impowerx-ta-row-actions { display: flex; justify-content: flex-end; gap: 2px; }
    .impowerx-ta-icon-btn { width: 28px; height: 28px; padding: 0; border: 0; border-radius: 6px; background: transparent; color: #6b7280;
      cursor: pointer; display: inline-flex; align-items: center; justify-content: center; }
    .impowerx-ta-icon-btn:hover { background: #f3f4f6; color: rgba(0,0,0,.88); }
    .impowerx-ta-delete-btn:hover { color: #b42318; background: #fef3f2; }
    .impowerx-ta-icon-btn:disabled { opacity: .5; cursor: default; }
    .impowerx-ta-row-busy { opacity: .55; pointer-events: none; }
    .impowerx-ta-spinner { display: inline-block; width: 14px; height: 14px; border: 2px solid rgba(0,0,0,.15); border-top-color: rgba(0,0,0,.6);
      border-radius: 50%; animation: impowerx-ta-spin .7s linear infinite; vertical-align: middle; }
    @keyframes impowerx-ta-spin { to { transform: rotate(360deg); } }
    /* One row: the summary wraps its own text; the pager keeps its width and stays on the right. */
    .impowerx-ta-footer { display: flex; align-items: center; justify-content: space-between; flex-wrap: nowrap; gap: 8px 16px; padding: 12px 16px;
      border-top: 1px solid #e5e5e5; color: #525252; font-size: 12px; }
    .impowerx-ta-summary { display: flex; align-items: center; flex-wrap: wrap; gap: 8px 16px; flex: 1 1 auto; min-width: 0; }
    .impowerx-ta-summary-left { display: inline-flex; align-items: center; gap: 6px; }
    .impowerx-ta-summary-left svg { color: #17b26a; }
    .impowerx-ta-pager { display: flex; align-items: center; gap: 8px; flex: 0 0 auto; margin-left: auto; color: #737373; white-space: nowrap; }
    .impowerx-ta-pager button { min-width: 28px; height: 28px; padding: 0 8px; border: 1px solid #e5e5e5; border-radius: 4px; background: #fff; color: #404040; font: inherit; font-size: 12px; cursor: pointer; display: inline-flex; align-items: center; justify-content: center; }
    .impowerx-ta-pager button svg { width: 14px; height: 14px; }
    .impowerx-ta-pager button[aria-current="page"] { border-color: #171717; font-weight: 600; color: #171717; }
    .impowerx-ta-pager button:disabled { color: #d4d4d4; cursor: default; }
  `
  document.head.appendChild(style)
}

const TECHNICAL_ASSET_TABLE_ICONS = {
  search:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>',
  prev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>',
  next: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>',
  sortNone:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m8 9 4-4 4 4"/><path d="m16 15-4 4-4-4"/></svg>',
  sortAsc:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 15 6-6 6 6"/></svg>',
  sortDesc:
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>',
}

function renderTechnicalAssetHeaderCell(column, sort) {
  if (!column.key) return `<th>${escapeHtml(column.label)}</th>`
  const dir = sort && sort.key === column.key ? sort.dir : null
  const ariaSort =
    dir === 'asc' ? 'ascending' : dir === 'desc' ? 'descending' : 'none'
  const icon =
    dir === 'asc'
      ? TECHNICAL_ASSET_TABLE_ICONS.sortAsc
      : dir === 'desc'
        ? TECHNICAL_ASSET_TABLE_ICONS.sortDesc
        : TECHNICAL_ASSET_TABLE_ICONS.sortNone
  return `<th scope="col" data-sort-key="${escapeHtml(column.key)}" aria-sort="${ariaSort}" role="button" tabindex="0" title="Nach „${escapeHtml(column.label)}“ sortieren"><span class="impowerx-ta-sort">${escapeHtml(column.label)}${icon}</span></th>`
}

function renderTechnicalAssetPagerHtml({ page, pages, shown, total }) {
  const count = `${shown} ${shown === 1 ? 'Eintrag' : 'Einträge'}`
  const text =
    shown === total
      ? `Seite ${page} von ${pages} (${count})`
      : `Seite ${page} von ${pages} (${shown} von ${total} ${total === 1 ? 'Eintrag' : 'Einträgen'})`
  const button = (target, content, label, current = false) =>
    `<button type="button" data-ta-page="${target}" aria-label="${escapeHtml(label)}"${current ? ' aria-current="page"' : ''}${target < 1 || target > pages ? ' disabled' : ''}>${content}</button>`
  // Only the current page sits between the arrows; "Seite x von y" carries the range.
  return `<nav class="impowerx-ta-pager" aria-label="Seiten"><span>${text}</span>${button(page - 1, TECHNICAL_ASSET_TABLE_ICONS.prev, 'Vorherige Seite')}${button(page, String(page), `Seite ${page}`, true)}${button(page + 1, TECHNICAL_ASSET_TABLE_ICONS.next, 'Nächste Seite')}</nav>`
}

/**
 * Shared table shell. `columns[i].cell(row, ctx)` returns escaped HTML; the trailing actions
 * column is added here. Columns with a `key` and `sortValue(row, ctx)` get a sortable
 * header. `rows` are the rows left after search/filters; sorting and paging follow
 * `ctx.view` (`sort`, `page`), and the clamped page is written back to `ctx.view.page`.
 *
 * @param {object} opts
 * @param {Array<{ key?: string, label: string, width: number, cell: (row: object, ctx: object) => string, sortValue?: (row: object, ctx: object) => unknown }>} opts.columns
 * @param {Array<object>} opts.rows
 * @param {string} opts.emptyText when the property has no rows of this kind at all
 * @param {string} opts.deleteAriaLabel
 * @param {string} opts.summaryHtml stats over all rows of the property
 * @param {object} opts.ctx render context (detailHref, contactNames, highlightsByAssetId, view, total)
 */
function renderTechnicalAssetsTableShellHtml(opts) {
  const { columns, rows, emptyText, deleteAriaLabel, summaryHtml, ctx } = opts
  const view = ctx.view || emptyTechnicalAssetView()
  const total = typeof ctx.total === 'number' ? ctx.total : rows.length
  const sorted = sortTechnicalAssetRows(rows, view.sort, columns, ctx)
  const paged = pageTechnicalAssetRows(sorted, view.page)
  view.page = paged.page
  const colgroup = `<colgroup>${columns.map((c) => `<col style="width:${c.width}%">`).join('')}<col style="width:10%"></colgroup>`
  const head = columns
    .map((c) => renderTechnicalAssetHeaderCell(c, view.sort))
    .join('')
  const emptyCopy =
    total === 0 ? emptyText : 'Keine Einträge für diese Suche oder Filter.'
  const span = columns.length + 1
  // Same shape as the insurance table: the header stays, the body carries the state.
  const body = ctx.loading
    ? `<tr class="impowerx-ta-loading"><td colspan="${span}" role="status"><span class="impowerx-ta-spinner" aria-hidden="true"></span>${escapeHtml(ctx.loading)}</td></tr>`
    : ctx.error
      ? `<tr class="impowerx-ta-error"><td colspan="${span}" role="alert">${escapeHtml(ctx.error)}</td></tr>`
      : ctx.notice
        ? `<tr class="impowerx-ta-empty"><td colspan="${span}" role="status">${escapeHtml(ctx.notice)}</td></tr>`
        : paged.visible.length === 0
          ? `<tr class="impowerx-ta-empty"><td colspan="${span}">${escapeHtml(emptyCopy)}</td></tr>`
          : paged.visible
              .map(
                (
                  a
                ) => `<tr class="impowerx-ta-row" data-row-key="${escapeHtml(String(a.id))}" data-row-name="${escapeHtml(a.name || '')}">
              ${columns.map((c) => `<td>${c.cell(a, ctx)}</td>`).join('')}
              <td>${renderTechnicalAssetActionsCell(a, ctx, deleteAriaLabel)}</td>
            </tr>`
              )
              .join('')
  const footer = total
    ? `<footer class="impowerx-ta-footer">${summaryHtml}${renderTechnicalAssetPagerHtml({ page: paged.page, pages: paged.pages, shown: rows.length, total })}</footer>`
    : ''
  return `<div class="impowerx-ta-table-wrap">
    <div class="impowerx-ta-table-scroll">
      <table class="impowerx-ta-table">
        ${colgroup}
        <thead><tr>${head}<th class="impowerx-ta-col-actions">Aktionen</th></tr></thead>
        <tbody>${body}</tbody>
      </table>
    </div>
    ${footer}
  </div>`
}

/**
 * Search field plus Gebäude (and, for the mixed table, Typ) filters above a
 * sub-section table. Built once per table host; `refreshTechnicalAssetControls`
 * keeps the option lists current without losing the typed search.
 *
 * @param {{ showKind: boolean, searchPlaceholder: string }} opts
 */
function buildTechnicalAssetControls(opts) {
  const controls = document.createElement('div')
  controls.className = 'impowerx-ta-controls'
  controls.innerHTML = `<div class="impowerx-ta-filters"><span class="impowerx-ta-filters-label">Filter:</span>
      <select data-ta-filter="building" aria-label="Nach Gebäude filtern"><option value="">Gebäude: Alle</option></select>
      ${opts.showKind ? '<select data-ta-filter="kind" aria-label="Nach Typ filtern"><option value="">Typ: Alle</option></select>' : ''}
    </div>
    <label class="impowerx-ta-search">${TECHNICAL_ASSET_TABLE_ICONS.search}<input type="search" data-ta-search aria-label="${escapeHtml(opts.searchPlaceholder)}" placeholder="${escapeHtml(opts.searchPlaceholder)}"></label>`
  return controls
}

/** @returns {string} the value that is still selectable ('' when the option disappeared) */
function setTechnicalAssetSelectOptions(select, options, firstLabel, selected) {
  if (!select) return ''
  select.innerHTML = `<option value="">${escapeHtml(firstLabel)}</option>${options
    .map(
      (option) =>
        `<option value="${escapeHtml(String(option.value))}">${escapeHtml(option.label)}</option>`
    )
    .join('')}`
  const value = options.some((option) => String(option.value) === selected)
    ? selected
    : ''
  select.value = value
  return value
}

/**
 * Option lists follow the loaded rows; the controls show the view's current
 * values (a filter whose option vanished is cleared on the view as well).
 *
 * @param {HTMLElement} controls
 * @param {{ buildings: Array<{ value: string|number, label: string }>, kinds: Array<string> }} options
 * @param {{ search: string, building: string, kind: string }} view
 */
function refreshTechnicalAssetControls(controls, options, view) {
  view.building = setTechnicalAssetSelectOptions(
    controls.querySelector('[data-ta-filter="building"]'),
    options.buildings,
    'Gebäude: Alle',
    String(view.building || '')
  )
  const kindSelect = controls.querySelector('[data-ta-filter="kind"]')
  if (kindSelect) {
    view.kind = setTechnicalAssetSelectOptions(
      kindSelect,
      (options.kinds || []).map((kind) => ({ value: kind, label: kind })),
      'Typ: Alle',
      String(view.kind || '')
    )
  }
  const search = controls.querySelector('[data-ta-search]')
  if (search && search.value !== view.search) search.value = view.search
}

function buildTechnicalAssetToolbarCreateLink(href) {
  const a = document.createElement('a')
  a.className = 'ant-btn ant-btn-ghost Button impowerx-ta-create'
  a.href = href
  a.setAttribute('role', 'button')
  const icon = document.createElement('span')
  icon.setAttribute('role', 'img')
  icon.className = 'anticon'
  icon.innerHTML =
    '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 7H9V0H7V7H0V9H7V16H9V9H16V7Z" fill="black"></path></svg>'
  a.appendChild(icon)
  a.appendChild(document.createTextNode('Hinzufügen'))
  return a
}

/**
 * Build one Impower-style `.sub-section`: header row with title, entry count and the
 * "Hinzufügen" link, then the table host. `tableHost` is empty and is filled by the caller;
 * `setCount(n)` updates the "(n Einträge)" suffix in the header.
 *
 * @param {object} opts
 * @param {{ key: string, title: string, idPrefix: string, createTyp?: string }} opts.def
 * @param {string} opts.propertyHrId
 * @param {number|undefined|null} opts.propertyId
 * @returns {{ wrap: HTMLElement, tableHost: HTMLElement, setCount: (n: number|null) => void }}
 */
function buildTechnicalAssetSubSection(opts) {
  const { def, propertyHrId, propertyId } = opts

  const wrap = document.createElement('div')
  wrap.className = 'sub-section impowerx-technical-assets-lux-root'
  wrap.id = def.idPrefix
  wrap.setAttribute('data-section-key', def.key)
  if (propertyId != null) {
    wrap.setAttribute('data-lux-property-id', String(propertyId))
    wrap.setAttribute('data-lux-property-hr-id', String(propertyHrId))
  }

  const header = document.createElement('div')
  header.className = 'sub-section-header '
  const title = document.createElement('div')
  title.className = 'sub-section-title'
  title.textContent = def.title
  const count = document.createElement('span')
  count.className = 'impowerx-ta-title-count'
  title.appendChild(count)
  header.appendChild(title)
  header.appendChild(
    buildTechnicalAssetToolbarCreateLink(
      luxTechnicalAssetCreateUrl(propertyHrId, def.createTyp)
    )
  )

  const content = document.createElement('div')
  content.className = 'sub-section-content'
  const tableHost = document.createElement('div')
  tableHost.className = 'impowerx-technical-assets-lux-wrap'
  content.appendChild(tableHost)

  wrap.appendChild(header)
  wrap.appendChild(content)
  const setCount = (n) => {
    count.textContent =
      n == null ? '' : `(${n} ${n === 1 ? 'Eintrag' : 'Einträge'})`
  }
  return { wrap, tableHost, setCount }
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    renderTechnicalAssetsTableShellHtml,
    renderTechnicalAssetPagerHtml,
    buildTechnicalAssetControls,
    refreshTechnicalAssetControls,
  }
}
